import React from 'react'
import AccountPricingList from './AccountPricingList'
import { selectNavHeight } from "../../../../redux/navbar/navHeightSlice";
import { useSelector } from "react-redux";

const AccountPricingListPage = () => {
  const navHeight = useSelector(selectNavHeight);
  
  return (
  <div  className="mx-auto w-full"
    style={{
      marginTop: navHeight,
      height: `calc(100vh - ${navHeight}px)`,
      overflow: "auto",
    }} >
      <AccountPricingList />
    </div>
  );
}

export default AccountPricingListPage